'use client';

import React, { useState } from 'react';
import { IMember } from '@/types/members.types';
import { IUserInfo } from '@/types/shared.types';
import { ContactDetails as ContactDetailsView } from '@/components/page/member-details/contact-details';
import { MemberProfileLoginStrip } from '@/components/page/member-details/member-details-login-strip';
import { EditContactForm } from '@/components/page/member-details/ContactDetails/components/EditContactForm';

import s from './ContactDetails.module.scss';
import { useMemberAnalytics } from '@/analytics/members.analytics';
import { useMobileNavVisibility } from '@/hooks/useMobileNavVisibility';
import { DetailsSection } from '@/components/common/profile/DetailsSection';

export type ContactDetailsVariant = 'default' | 'drawer';

interface Props {
  member: IMember;
  isLoggedIn: boolean;
  userInfo: IUserInfo | null;
  variant?: ContactDetailsVariant;
}

export const ContactDetails = ({ isLoggedIn, userInfo, member, variant = 'default' }: Props) => {
  const [editView, setEditView] = useState(false);
  const { onEditContactDetailsClicked } = useMemberAnalytics();
  useMobileNavVisibility(editView);

  const isDrawer = variant === 'drawer';

  return (
    <DetailsSection editView={editView} classes={{ root: s.root }}>
      {!isLoggedIn && !isDrawer && <MemberProfileLoginStrip member={member} variant="secondary" />}
      {editView ? (
        <EditContactForm
          onClose={() => setEditView(false)}
          member={member}
          userInfo={userInfo!}
          linkedinRequired={false}
          variant={variant}
        />
      ) : (
        <ContactDetailsView
          member={member}
          isLoggedIn={isLoggedIn}
          userInfo={userInfo!}
          variant={variant}
          onEdit={() => {
            onEditContactDetailsClicked();
            setEditView(true);
          }}
        />
      )}
    </DetailsSection>
  );
};
